<template>
  <div class="mt-10px">

    <div
      class="my-2 ml-4">
      <div v-for="(line) of maxAnswerNums[fieldId] " :key="line"
        class="groupInputs mt-2 mb-3">
        <div class="mt-10px">
          <span class="deleteText mt-10px">削除</span>
        </div>
        <div class="deleteBtn">
          <img
            src="@/assets/svg/close.svg"
            v-if="writable"
            @click="removeTr(line)"
            class="tdDeleteBtn">
        </div>
        <div>
          <div
            v-for="(option, index) in options" :key="index"
            class="inlineBlock mr-20px mt-10px">
            <span class="ml-1 mb-1">{{option.label}}</span>
            <b-form-input
              :disabled="!writable"
              :class="[
                optionData(option.id, line).errMessages.length > 0 ? 'errItem' : '',
                'inputTemplate_' + option.view_template,
              ]"
              :maxLength="option.max"
              :value="optionData(option.id, line).field_answer_text"
              @input="kickSetText($event, option.id, line)"
              v-if="option.input_type===tableInputTypes.TEXT ||
                option.input_type===tableInputTypes.NUMBER"
              :placeholder="option.placeholder"/>
            <b-form-select
              :disabled="!writable"
              :class="[
                optionData(option.id, line).errMessages.length > 0 ? 'errItem' : '',
                'inputTemplate_' + option.view_template,
              ]"
              :value="optionData(option.id, line).field_answer_id"
              v-if="option.input_type===tableInputTypes.SELECT"
              @input="kickSetSelect($event, option.id, line)"
              :options="option.choice_texts">
              >
              <template v-slot:first>
                <option :value="null" selected>-- 選択してください。 --</option>
              </template>
            </b-form-select>
            <span
              v-if="option.input_type===tableInputTypes.FIXED">
              {{option.choice_texts}}
            </span>

            <b-row class="ml-1"
              v-for="(msg, index) in optionData(option.id, line).errMessages" :key="index">
              <p class="error my-1">
                {{msg}}
              </p>
            </b-row>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flexRight"
      v-if="writable">
      <b-button
      class="addBtn"
      :disabled="!(this.maxAnswerNums[this.fieldId] < this.max_input_number)"
      @click="addTr"
      variant="outline-primary">
        <img class="plus" src="@/assets/svg/plus.svg">
        入力欄を追加
      </b-button>
    </div>
  </div>
</template>
<script>
import CONST_OPTIONS from '@/constants/options';

export default {
  name: 'PartsApplicationTable',
  props: {
    fieldId: { type: Number },
    is_variable: { type: [Boolean, Number], default: true },
    input_number: { type: Number, default: 1 },
    min_input_number: { type: Number, default: 1 },
    max_input_number: { type: Number, default: 1 },
    options: {
      type: Array,
      default: () => {
        return [
          {
            id: '',
            label: '',
            input_type: null,
            prefix: '',
            suffix: '',
            parent_option_id: null,
            parent_choice_id: null,
            view_template: 1,
          },
        ];
      },
    },
    notice: {},
    writable: { type: Boolean, default: false },
  },
  data() {
    return {
    };
  },
  methods: {
    addTr() {
      if (this.maxAnswerNums[this.fieldId] < this.max_input_number) {
        // データ上で入力項目の数を追加し、入力欄を追加する
        const newLineNum = this.maxAnswerNums[this.fieldId] + 1;
        const addParam = this._getInputParameter(newLineNum);
        const ansNumParam = {
          fieldId: this.fieldId,
          newLineNum,
        };
        this.$store.commit('gasApplicationInput/setMaxAnswerNums', ansNumParam);
        this.$store.commit('gasApplicationInput/addInputs', addParam);
      }
    },
    removeTr(line) {
      if (this.maxAnswerNums[this.fieldId] > this.min_input_number) {
        // 末尾の入力欄を削除し、入力項目の数も１つ減らす
        const removeParam = {
          fieldId: this.fieldId,
          line,
        };
        const newLineNum = this.maxAnswerNums[this.fieldId] - 1;
        const ansNumParam = {
          fieldId: this.fieldId,
          newLineNum,
        };
        this.$store.commit('gasApplicationInput/removeInputs', removeParam);
        this.$store.commit('gasApplicationInput/setMaxAnswerNums', ansNumParam);
      }
    },
    _getInputParameter(newLineNum) {
      const params = [];
      const commonParam = {
        field_id: this.fieldId,
        answer_no: newLineNum,
      };
      this.options.forEach((option) => {
        const param = Object.assign({}, commonParam);
        param.option_id = option.id;
        params.push(param);
      });
      return params;
    },
    kickSetText(value, optionId, lineNum) {
      const param = {
        field_id: this.fieldId,
        option_id: optionId,
        answer_no: lineNum,
        value,
      };
      this.$emit('kickSetText', param);
    },
    kickSetSelect(value, optionId, lineNum) {
      let setValue = value;
      if (setValue) {
        setValue = Number(setValue);
      }
      const param = {
        field_id: this.fieldId,
        option_id: optionId,
        answer_no: lineNum,
        value: setValue,
      };
      this.$emit('kickSetSelect', param);
    },
  },
  computed: {
    maxAnswerNums() {
      return this.$store.state.gasApplicationInput.maxAnswerNums;
    },
    tableInputTypes() {
      return CONST_OPTIONS.TABLE_INPUT_TYEPS;
    },
    optionData() {
      const self = this;
      return (optionId, line) => {
        const { inputs } = this.$store.state.gasApplicationInput;
        const optionData = inputs.find((input) => {
          const sameField = input.field_id === self.fieldId;
          const sameOption = input.option_id === optionId;
          const sameAnswerNo = input.answer_no === line;
          return sameField && sameOption && sameAnswerNo;
        });
        if (typeof optionData === 'undefined') {
          return [];
        }
        return optionData;
      };
    },
  },
};
</script>

<style scoped>
  .errItem {
    border:solid 1px #dc3545 !important;
  }
  .error {
    font-size: 80%;
    color: #dc3545;
    /* bootstrapで太字が当てられていたので。 */
    font-weight: normal;
  }

  input, select {
    height: 50px;
  }

  .addBtn {
    color:#0A8EA7 !important;
    border-color: #0A8EA7 !important;
    border-radius: 30px;
    width: 200px;
  }

  .plus {
    margin-bottom: 4px;
  }

  .btn-outline-primary:hover {
    background-color: #fff;
    opacity: 0.6;
  }

  .inputTemplate_1 {
    width: 200px;
  }
  .inputTemplate_2 {
    width: 310px;
  }

  .mr-20px {
    margin-right: 20px;
  }

  .mt-10px {
    margin-top: 10px;
  }

  .deleteText {
    position: absolute;
    right: 50px;
  }

  .deleteBtn {
    position: absolute;
    right: 50px;
    transform: translateY(285%);
    cursor: pointer;
  }

  .groupInputs {
    width: 750px;
  }

  /* 最初の入力欄の集合以外の上部に線を入れる */
  .groupInputs:nth-of-type(n+2) {
    border-top: solid 1px #E6E6E6;
  }

</style>
